import { Link as RouterLink } from 'react-router'
import DarkMode from '@mui/icons-material/DarkMode'
import LightMode from '@mui/icons-material/LightMode'
import { IconButton, Link, Toolbar, Stack } from '@mui/material'
import Logo from '@/assets/Logo'
import useThemeMode from '@/hooks/useThemeMode'
import useIsSuperUser from '@/services/hooks/useIsSuperUser'
import AccountPicker from '@/components/accounts/AccountPicker'
import ProfileMenu from './ProfileMenu'
import SuperUserMenu from './SuperUserMenu'

export default function AppTopBarLite() {
  const isSuperUser = useIsSuperUser()
  const [themeMode, setThemeMode] = useThemeMode()

  return (
    <header>
      <Toolbar
        component={Stack}
        direction="row"
        disableGutters
        justifyContent="space-between"
        variant="dense"
        sx={{ py: '2px' }}
      >
        <Stack direction="row">
          <Link
            ml={1}
            mb={2.5}
            to="/lite"
            component={RouterLink}
            sx={{
              position: 'relative',
              '&::after': {
                content: '"LITE"',
                fontSize: '0.7em',
                letterSpacing: '0.05em',
                color: 'warning.main',
                position: 'absolute',
                top: '3px',
                right: '-30px',
              },
            }}
          >
            <Logo />
          </Link>
        </Stack>
        <Stack direction="row" alignItems="center">
          <AccountPicker isLite />
          <IconButton
            size="small"
            onClick={() =>
              setThemeMode((prev) => (prev === 'dark' ? 'light' : 'dark'))
            }
          >
            {themeMode === 'dark' ? <DarkMode /> : <LightMode />}
          </IconButton>
          <ProfileMenu isLite />
          {isSuperUser && <SuperUserMenu />}
        </Stack>
      </Toolbar>
    </header>
  )
}
